import { Injectable, computed, inject, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { finalize, Observable, shareReplay, tap } from 'rxjs';
import { HttpService } from './http.service';
import { UserCompanyDataModel } from '@models/user-company-data/user-company-data.model';

@Injectable({
  providedIn: 'root',
})
export class UserCompanyDataService {
  private readonly userCompanyDataApi = !environment.isFullOnline
    ? `${environment.caisseApiUrl}/user-company-datas`
    : `${environment.caisseApiUrl}/user_company_datas`;
  private readonly httpService = inject(HttpService);

  private readonly userCompanyData = signal<UserCompanyDataModel | null>(null);
  private inFlight$: Observable<UserCompanyDataModel> | null = null;

  readonly currentUserCompanyData = computed(() => {
    return this.userCompanyData();
  });

  getUserCompanyData(userId: number): Observable<UserCompanyDataModel> {
    return this.loadUserCompanyData(userId);
  }

  loadUserCompanyData(userId: number): Observable<UserCompanyDataModel> {
    if (!this.inFlight$) {
      this.inFlight$ = this.httpService
        .get<UserCompanyDataModel>(this.userCompanyDataApi + `/user/${userId}`)
        .pipe(
          tap((data) => {
            this.userCompanyData.set(data);
          }),
          finalize(() => {
            this.inFlight$ = null;
          }),
          shareReplay(1),
        );
    }
    return this.inFlight$;
  }
}
